import { Column } from "@/components/Table/Table";

export const transportModes = [
  {
    label: "Commercial vehicle",
    value: "Commercial vehicle",
  },
  {
    label: "Truck / Lorry",
    value: "Truck / Lorry",
  },
  {
    label: "Containership",
    value: "Containership",
  },
  {
    label: "Aircraft",
    value: "Aircraft",
  },
  {
    label: "Train",
    value: "Train",
  },
  {
    label: "No transport",
    value: "No transport",
  },
];

export const transportDetailUploadColumns: Column[] = [
  {
    key: "order_id",
    label: "Order ID",
    searchable: true,
  },
  {
    key: "departure_address",
    label: "Departure address",
    searchable: true,
  },
  {
    key: "arrival_address",
    label: "Arrival address",
    searchable: true,
  },
  {
    key: "transport_mode",
    label: "Mode of transport",
  },
  {
    key: "owned",
    label: "Owned or leased",
  },
];

export const transportUploadFilters = {
  status: [
    { label: "Complete", value: "complete" },
    { label: "Incomplete", value: "incomplete" },
    { label: "Error", value: "error" },
    { label: "Calculating", value: "calculating" },
  ],
};
